<section *ngIf="isEnvironmentSandbox" class="test-banner">
  <div class="inner">
    <span>TEST DATA</span>
  </div>
</section>
